/**
 * Validación de identificadores antes de meterlos en una URL.
 *
 * El origen del problema: en varios sitios se construía la ruta con `path.replace(':id', item.id)`
 * sin comprobar nada. Cuando `item` venía incompleto (una fila que ya no existe, un índice de tabla
 * desincronizado, un evento sin cargar), el id era `undefined` y la plantilla se resolvía a la
 * cadena literal "undefined". A partir de ahí:
 *
 *  - `/sessions/edit/undefined` pedía la sesión "undefined", el servidor devolvía null y el
 *    formulario se quedaba vacío para siempre, sin decir nada.
 *  - `?session=undefined` era una cadena con contenido, así que pasaba cualquier comprobación de
 *    verdadero y el calendario reintentaba abrirla en bucle.
 *
 * El truco está en que "undefined" como TEXTO es un valor perfectamente válido para JavaScript:
 * por eso hay que rechazarlo explícitamente y no basta con un `if (id)`.
 */

/** Cadenas que llegan de un `undefined` o `null` convertido a texto por accidente. */
const BROKEN_IDS = new Set(['undefined', 'null', 'NaN', '']);

/**
 * ¿Se puede usar este identificador para navegar o consultar?
 *
 * @param {*} id
 * @returns {boolean}
 */
export const isValidId = (id) => {
  if (id === null || id === undefined) return false;

  return !BROKEN_IDS.has(String(id).trim());
};

/**
 * Sustituye `:id` en una plantilla de ruta, devolviendo null si el identificador no sirve.
 * Devolver null (en vez de una ruta rota) obliga a quien llama a decidir qué hacer.
 *
 * @param {string} template ruta con `:id`, por ejemplo '/sessions/edit/:id'
 * @param {*} id
 * @returns {?string}
 */
export const buildPathWithId = (template, id) => {
  if (!template || !isValidId(id)) return null;

  return template.replace(':id', String(id));
};
